// 9fbef606107a605d69c0edbcd8029e5d
import constants from './StyliticsProductTabList.constants';

const initialState = {
  outfitSeoData: {},
};

const StyliticsProductTabListReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case constants.STYLITICS_PRODUCT_TAB_LIST_REQ: {
      const { categoryId } = payload;
      return { ...state, completed: { ...state.completed, [categoryId]: true } };
    }
    case constants.STYLITICS_FLUSH_DATA:
      return { outfitSeoData: {}, oufitPLPData: state.oufitPLPData };
    case constants.STYLITICS_PRODUCT_TAB_LIST_SUCCESS:
    case constants.STYLITICS_PRODUCT_TAB_LIST_FAIL:
      return {
        ...state,
        ...payload,
        errors: { ...state.errors, ...payload.errors },
        completed: { ...state.completed, ...payload.completed },
      };
    case constants.OUTFIT_PLP_DATA_SUCCESS:
    case constants.OUTFIT_PLP_DATA_FAIL:
      return {
        ...state,
        oufitPLPData: { ...state.oufitPLPData, ...payload },
      };

    case constants.IS_FETCHING_DATA_FOR_OUTFIT:
      return {
        ...state,
        isFetchingDataForOutfit: payload,
      };
    case constants.SET_OUTFIT_SEO_DATA: {
      const { page = '', seoHeaderCopy = '' } = action.payload;
      return {
        ...state,
        outfitSeoData: {
          ...state?.outfitSeoData,
          [page]: seoHeaderCopy,
        },
      };
    }
    case constants.BAG_OUTFIT_PRODUCTS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default StyliticsProductTabListReducer;
